import { motion } from "framer-motion";
import Icon from "@/components/site/Icon";
import { STEPS } from "@/data/content";

export default function HowItWorks() {
  return (
    <section id="so-funktioniert-es" className="section-pad bg-white" data-testid="section-so-funktioniert-es">
      <div className="container-x">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-sm font-bold tracking-wide text-[color:var(--brand-green-alt)] uppercase">So funktioniert es</span>
          <h2 className="mt-2 font-display text-4xl sm:text-5xl text-[color:var(--brand-navy)]">So funktioniert der Hausnotruf</h2>
          <p className="mt-3 text-base sm:text-lg text-muted-foreground">In vier einfachen Schritten von der Alarmierung bis zur Hilfe – zuverlässig, diskret und einfach.</p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.4, delay: i * 0.06 }}
              className="relative rounded-2xl border border-border bg-white p-6 card-shadow card-shadow-hover"
            >
              <div className="flex items-center gap-3">
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-[color:var(--brand-green)] text-white font-display text-2xl">{s.n}</span>
                <Icon name={s.icon} className="h-7 w-7 text-[color:var(--brand-navy)]" />
              </div>
              <h3 className="mt-4 text-lg font-bold text-[color:var(--brand-navy)]">{s.title}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-muted-foreground">{s.text}</p>
            </motion.div>
          ))}
        </div>

        <div className="mt-8 flex items-center justify-center gap-3 rounded-2xl bg-secondary border border-border px-6 py-4">
          <Icon name="ShieldCheck" className="h-6 w-6 text-[color:var(--brand-green-alt)]" />
          <p className="text-sm sm:text-base font-semibold text-[color:var(--brand-navy)]">
            Zuverlässig. Diskret. Einfach. – Das System funktioniert rund um die Uhr, für ein sicheres Gefühl, jeden Tag.
          </p>
        </div>
      </div>
    </section>
  );
}
